module.exports = __webpack_public_path__ + "static/media/logout.8666b4bd.svg";